<form class="itinerary-model-content-inner">
  <div class="itinerary-model-content">
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Templates</ion-title>
    </div>
  
    <div class="form-container ion-padding-horizontal" *ngIf="allInventoryTemplates">

      <div class="row">
        <div class="col-4 p-1" *ngFor="let template of sanitizedTemplates">
          <div class="template-main-container">
            <div class="template-title-container">
              <p class="title mb-0 mb-1">{{template.name}}</p>
            </div>
            <div class="cover-container">
              <!-- Use the sanitized content here -->
              <div class="cover-page" [innerHtml]="template.content"></div>
              <div class="action-btns-container">
                <!-- Buttons here, if needed -->
              </div>
            </div>
      
            <div class="select-container">
              <input
                class="d-none"
                type="radio"
                name="template"
                [checked]="template.templateId === selectedTemplateId"
                [attr.id]="template.templateId"
                [value]="template.templateId"
                [(ngModel)]="selectedTemplateId"
              />
              <label
                class="select-btn checkbox-label"
                [attr.for]="template.templateId"
                (click)="changeSelectedTemplate(template.templateId)"
              >
                {{ selectedTemplateId === template.templateId ? 'Selected' : 'Select' }}
              </label>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn invisible">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn invisible">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn invisible">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>
